// Copyright (c) 2016 Deere & Company

import Facets from '../../state/facets';
import PipSearchFacetsContainer from './pip-search-facets-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.pips.pipSearch,
    facets: new Facets({
        ...state.pips.pipSearch.facets,
        dealerAccountsFacet: {
            ...state.pips.pipSearch.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    searchByType: state.pips.pipSearch.searchByType,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PipSearchFacetsContainer);



// WEBPACK FOOTER //
// ./src/pip/pip-search/components/pip-search-facets/index.js